import { lazy } from "react";
import { Redirect, useSearch } from "wouter";
import { legacySocialPostingDestination } from "@/lib/socialPostingNavigation";

const MessagingView = lazy(() => import("@/pages/MessagingView"));

export default function MessagingRoute() {
  const search = useSearch();
  const destination = legacySocialPostingDestination(
    search,
    typeof window === "undefined" ? "" : window.location.hash,
  );
  // Do not load the email composer or consume a social hand-off on this route.
  return destination ? <Redirect to={destination} replace /> : <MessagingView />;
}